// ✅ Visitor Layout – Clone of SetupLayout
// Created on 2025-11-19

import React, { useState, useEffect } from "react";
import VisitorSidebar from "../components/visitor/VisitorSidebar";
import { MdMenu } from "react-icons/md";

export default function VisitorLayout({ children }) {
  const [mobileOpen, setMobileOpen] = useState(false);
  const [collapsed, setCollapsed] = useState(
    localStorage.getItem("visitor_sidebar_collapsed") === "true"
  );
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 992);

  useEffect(() => {
    const onResize = () => setIsMobile(window.innerWidth <= 992);
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);

  useEffect(() => {
    const watcher = setInterval(() => {
      const lsVal = localStorage.getItem("visitor_sidebar_collapsed") === "true";
      setCollapsed(lsVal);
    }, 300);
    return () => clearInterval(watcher);
  }, []);

  useEffect(() => {
    if (isMobile) {
      document.body.style.overflow = mobileOpen ? "hidden" : "auto";
    }
  }, [mobileOpen, isMobile]);

  const sidebarWidth = collapsed ? 64 : 260;
  const mainMargin = !isMobile ? sidebarWidth : 0;

  return (
    <div className="tf-setup-layout" style={{ width: "100%", overflowX: "hidden" }}>
      
      <VisitorSidebar mobileOpen={mobileOpen} setMobileOpen={setMobileOpen} />

      {/* Mobile Hamburger */}
      {isMobile && (
        <button
          className="tf-mobile-menu"
          onClick={() => setMobileOpen(true)}
          aria-label="Open Sidebar"
        >
          <MdMenu size={22} />
        </button>
      )}

      {/* Main Content */}
      <main
        className="tf-main-content"
        style={{
          marginLeft: mainMargin,
          padding: "20px",
          transition: "margin-left 0.25s ease",
          minHeight: "100vh",
          width: isMobile ? "100%" : `calc(100% - ${sidebarWidth}px)`,
          overflowX: "hidden",
          boxSizing: "border-box",
        }}
      >
        {children}
      </main>
    </div>
  );
}
